import { render } from "./JenisPiket.vue?vue&type=template&id=d43b3a24"
import script from "./JenisPiket.vue?vue&type=script&lang=js"
export * from "./JenisPiket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__